export function getMinForMaxField(internalMin: number | null, min: number | undefined): number | undefined {
  if (internalMin !== null && typeof min !== 'undefined') {
    return internalMin < min ? min : internalMin;
  } else if (internalMin !== null) {
    return internalMin;
  } else if (typeof min !== 'undefined') {
    return min;
  }

  return undefined;
}
